var map = {
	"./down-arrow--thin.svg": 35462,
	"./down-arrow.svg": 89103,
	"./down-arrow.svg.js": 89103,
	"./icon-autoML-spinner.svg": 10821,
	"./icon-brain-black.svg": 9565,
	"./icon-build.svg": 94915,
	"./icon-bullet-check.svg": 97247,
	"./icon-check--pink.svg": 96957,
	"./icon-check.svg": 83449,
	"./icon-checkmark.svg": 17034,
	"./icon-code.svg": 15852,
	"./icon-comparison-check.svg": 60144,
	"./icon-cs-automation.svg": 54688,
	"./icon-cs-cg.svg": 61575,
	"./icon-cs-finance.svg": 45069,
	"./icon-cs-health.svg": 49057,
	"./icon-cs-manufacturing.svg": 79492,
	"./icon-cs-marketing.svg": 64595,
	"./icon-cs-retail.svg": 75537,
	"./icon-cs-sustainability.svg.svg": 27291,
	"./icon-cs-telecoms.svg": 85202,
	"./icon-cs-transformation.svg": 75765,
	"./icon-deploy.svg": 81306,
	"./icon-empowering.svg": 84359,
	"./icon-facebook--sitemap.svg": 34779,
	"./icon-facebook-dark.svg": 36028,
	"./icon-faster.svg": 99601,
	"./icon-full-autoML-default.svg": 40975,
	"./icon-full-autoML-missing-spinner.svg": 18033,
	"./icon-instagram--sitemap.svg": 25156,
	"./icon-link.svg": 53003,
	"./icon-linkedin--sitemap.svg": 36402,
	"./icon-linkedin-color.svg": 47104,
	"./icon-linkedin.svg": 39142,
	"./icon-models.svg": 57809,
	"./icon-play.svg": 39346,
	"./icon-quotemark.svg": 72494,
	"./icon-quotes.svg": 74250,
	"./icon-twitter--colored.svg": 78670,
	"./icon-twitter--sitemap.svg": 1553,
	"./icon-twitter-dark.svg": 6331,
	"./icon-twitter.svg": 59843,
	"./icon-v-pause.svg": 66148,
	"./icon-v-play.svg": 95300,
	"./icon-value.svg": 71592,
	"./icon_ai.svg": 53553,
	"./icon_apps.svg": 94691
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8203;